<template>
  <modal ref='bulkDeleteItemsModal' class="upload-files-modal">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('bulk_items.delete.bulk_delete') }} </h5>
    </template>

    <template #body>
      <form class="modal-fix">
        <div class='modal-body'>
          <p> {{ $t('bulk_items.delete.remove_checked_items') }} </p>
        </div>

        <div class='modal-footer'>
          <a @click.prevent="closeModal()" class="btn btn-outline-primary float-right" href="">{{ $t('share_invite.close') }}</a>
          <a @click.prevent="bulkDeleteRecordsFolders()" class="btn btn-danger float-right" href=""> {{ $t('bulk_items.delete.delete') }} </a>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import _modal from './../../_modal'


export default {
  components: {
    'modal': _modal,
  },
  data: function () {
    return {
      folderIds: [],
      recordIds: []
    }
  },
  methods: {
    open(folders, records) {
      this.folderIds = (folders || []).map(f => f.id)
      this.recordIds = (records || []).map(r => r.id)
      this.$refs.bulkDeleteItemsModal.open()
    },
    closeModal() {
      this.$refs.bulkDeleteItemsModal.close()
    },
    bulkDeleteRecordsFolders(){
      let paramsRecords = {ids: this.recordIds}
      let paramsFolders = {ids: this.folderIds}

      const promises = [
        this.store.bulkDeleteRecords(paramsRecords),
        this.store.bulkDeleteFolders(paramsFolders)
      ]

      Promise.allSettled(promises).then(() => {
        this.store.sendMetrics({name: 'bulk_delete_items', params: this.$route.params, path: this.$route.fullPath})
        this.$emit('success')
        this.$toastr.success(this.$t('bulk_items.delete.success'))
        this.closeModal()
      })
    }
  }
}
</script>

<style lang="sass" scoped>

</style>

